@if (componentData$ | async; as data) { @if (data.url !== '/bike/nl/nl/login') {
<cx-generic-link
  [ngClass]="getClass(styleClass, data.url)"
  [url]="data.url"
  [style]="data.styleAttributes"
  (click)="handleClick(data.url, $event)"
  >{{ data.linkName }}</cx-generic-link
>
} @else {
<a role="link" [href]="data.url">{{ data.linkName }}</a>
} }
